import { render, staticRenderFns } from "./introduce.vue?vue&type=template&id=1daa961f&scoped=true"
import script from "./introduce.vue?vue&type=script&lang=js"
export * from "./introduce.vue?vue&type=script&lang=js"
import style0 from "./introduce.vue?vue&type=style&index=0&id=1daa961f&prod&scoped=true&lang=css"
import style1 from "./introduce.vue?vue&type=style&index=1&id=1daa961f&prod&scoped=true&lang=css"
import style2 from "./introduce.vue?vue&type=style&index=2&id=1daa961f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1daa961f",
  null
  
)

export default component.exports